import { computed } from 'vue-demi';
import { use as fegoUse } from '@fegobull/webapi';

export function usePageTypeFlag() {
  const { usePageType } = fegoUse;
  const pageType = usePageType() as { isPC?: boolean | { value: boolean } };
  const raw = pageType && pageType.isPC;

  const isPC = computed(() => {
    if (raw && typeof raw === 'object' && 'value' in raw) {
      return Boolean(raw.value);
    }
    return Boolean(raw);
  });

  return { isPC };
}
